import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { Result, Button } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const PerformanceAccessControl = memo(({ children, requiredRoles = [], requiredPermissions = [] }) => {
  const navigate = useNavigate();
  const user = useSelector((state) => state.authSlice?.userDetail);
  const userRole = user?.accountType;
  const userPermissions = user?.permissions || [];

  // Check if user has required role
  const hasRequiredRole = requiredRoles.length === 0 || requiredRoles.includes(userRole);

  // Check if user has required permissions
  const hasRequiredPermissions = requiredPermissions.length === 0 || 
    requiredPermissions.every(permission => userPermissions.includes(permission));

  // Check if user is authorized
  const isAuthorized = hasRequiredRole && hasRequiredPermissions;

  if (!isAuthorized) {
    return (
      <Result
        icon={<LockOutlined />}
        title="Access Denied"
        subTitle="You don't have permission to access the Performance Dashboard. Please contact your administrator for access."
        extra={
          <Button type="primary" onClick={() => navigate('/dashboard')}>
            Go to Dashboard
          </Button>
        }
      />
    );
  }

  return children;
});

PerformanceAccessControl.displayName = 'PerformanceAccessControl';

export default PerformanceAccessControl;
